<template>
    <el-dropdown @command="handleCommand" style="margin-right:10px">
        <el-button type="text" size="small" icon="el-icon-s-management">管理</el-button>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="$utils.have('/activity/info')" :command="`/activityManage/activity/edit/baseInfo/${id}`">基本信息</el-dropdown-item>           
            <el-dropdown-item v-if="$utils.have('/activity/actSellSetting')" :command="`/activityManage/activity/edit/activityTicketPrices/${id}`">演出售票设置</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activity/sessions')" :command="`/activityManage/activity/edit/session/${id}`">场次设置</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activity/batchUpdateSessions')" :command="`/activityManage/activity/edit/batchUpdate/${id}`">批量更新场次信息</el-dropdown-item>
            <el-dropdown-item v-if="$utils.have('/activity/ticketPrices')" :command="`/activityManage/activity/edit/sessionsTicketPrices/${id}`">场次售票设置</el-dropdown-item>			
            <el-dropdown-item v-if="$utils.have('/activity/throughTicketPrices')" :command="`/activityManage/activity/edit/throughTicketPrices/${id}`">通票设置</el-dropdown-item>
            <el-dropdown-item v-if="$utils.have('/activity/presentTicketPrices')" :command="`/activityManage/activity/edit/presentTicket/${id}`">赠票管理</el-dropdown-item>
            <!-- <el-dropdown-item v-if="$utils.have('/activity/activitySeatInfo')" :command="`/activityManage/activity/edit/seatConfig/${id}`">选座设置</el-dropdown-item> -->
            <el-dropdown-item v-if="$utils.have('/missTicket/pageList')" :command="`/activityManage/activity/edit/lackTicket/${id}`">票品登记</el-dropdown-item>
            <el-dropdown-item v-if="$utils.have('/activity/approval')" :command="`/activityManage/activity/edit/approval/${id}`">报批信息</el-dropdown-item>
            <el-dropdown-item v-if="$utils.have('/activity/financeInfo')" :command="`/activityManage/activity/edit/finance/${id}`">财务信息</el-dropdown-item>
            <el-dropdown-item v-if="$utils.have('/activityUpdateRecord/list')" :command="`/activityManage/activity/edit/changeNotice/${id}`">变更通知</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activity/thirdList')" :command="`/activityManage/activity/edit/thirdList/${id}`">外部销售</el-dropdown-item>
            <el-dropdown-item v-if="$utils.have('/activity/thirdTicket')" :command="`/activityManage/activity/edit/thirdTicket/${id}`">主办自有售票渠道数据</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activity/statistics/summary')" :command="`/activityManage/activity/edit/activityDashboard/${id}`">数据统计</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activityUpdateLog/list')" :command="`/activityManage/activity/edit/updateLog/${id}`">修改日志</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activity/souvenir/ticket/detail')" :command="`/activityManage/activity/edit/souvenir/${id}`">纪念票设置</el-dropdown-item>
			<el-dropdown-item v-if="$utils.have('/activity/getSortScore')" :command="`/activityManage/activity/edit/sort/${id}`">演出其他设置</el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    props: {
        id: {
            type: [Number,String],
            default: "",
        },
        params: {
            type: Object,
            default: () => null
        },
		activityChannel:{
			type: Array,
			default: () => []
		}
    },
    data(){
        return{}
    },
	
    methods:{
        handleCommand(command){
            this.$router.push({
                path: command,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        {
                            ...this.params
                        }
                    ),
                },
            });
        }
    }
}
</script>